import React from 'react';

import type { NavigationTab } from '@swf/poker';
import { Navigation } from '@swf/poker';

import { SundayMillionTab } from '../../types';

import { TXTCLI_Main_Event_3, TXTCLI_Satellites } from './Nav.messages.json';
import styles from './Nav.scss';

const navTabs: NavigationTab<SundayMillionTab>[] = [
  {
    shortTitle: TXTCLI_Main_Event_3,
    title: TXTCLI_Main_Event_3,
    tabName: SundayMillionTab.Main
  },
  {
    shortTitle: TXTCLI_Satellites,
    title: TXTCLI_Satellites,
    tabName: SundayMillionTab.Satellites
  }
];

const Nav: React.FC<{
  selectedTab: SundayMillionTab;
  onSelectTab: (tab: SundayMillionTab) => void;
}> = ({ selectedTab, onSelectTab }) => (
  <header className={styles.root}>
    <Navigation navTabs={navTabs} selectedTab={selectedTab} onSelectTab={onSelectTab} />
  </header>
);

export default Nav;
